import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useSupabaseAuth } from '@/hooks/auth';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, XCircle, AlertTriangle } from 'lucide-react';

const CourseAssignmentValidator: React.FC = () => {
  const { user, profile, hasAccess } = useSupabaseAuth();
  const [assignments, setAssignments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAssignments();
  }, []);

  const fetchAssignments = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/assignments');
      const data = await response.json();
      setAssignments(data);
    } catch (error) {
      console.error('Error fetching assignments:', error);
    } finally {
      setLoading(false);
    }
  };

  const validateAssignments = () => {
    if (!user || !profile) {
      return <AlertTriangle className="h-4 w-4 mr-2 text-yellow-500" />
    }

    if (!hasAccess('admin')) {
      return <AlertTriangle className="h-4 w-4 mr-2 text-red-500" />
    }

    return <CheckCircle className="h-4 w-4 mr-2 text-green-500" />;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          Course Assignment Validator
          {validateAssignments()}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div>Loading assignments...</div>
        ) : (
          <div>
            <Badge>Total Assignments: {assignments.length}</Badge>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CourseAssignmentValidator;
